import React, {useEffect} from 'react';
import {Navigate} from 'react-router-dom';
import {useUser} from "../providers/UserContext";

const ProtectedRoute = ({ roles,  children }) => {
    const { userRole , token } = useUser();

    useEffect(()=>{
        // console.log(token, 'protected route ')
    }, [])
    if(!localStorage.getItem(("RUK_AUTH_TOKEN"))){
        return <Navigate to="/login" />;
    }
    // if (!roles.includes(userRole)) {
    //     return <Navigate to="/login" />;
    // }

    // else if (localStorage.getItem(("RUK_AUTH_TOKEN"))){
    //     return <Navigate to="/" />;
    // }


    return <>
        {children}
    </>

};

export default ProtectedRoute;